import React from 'react';
import { Button } from '../Button';
import SEO from '../SEO';
import '../styles/pages.css';

/**
 * Home Page - Main landing page
 */
export default function Home() {
  const features = [
    {
      id: 1,
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure tailored to your business needs',
      icon: '☁️'
    },
    {
      id: 2,
      title: 'AI & Analytics',
      description: 'Harness the power of artificial intelligence and data insights',
      icon: '🤖'
    },
    {
      id: 3,
      title: 'Security First',
      description: 'Enterprise-grade security protecting your digital assets',
      icon: '🔒'
    },
    {
      id: 4,
      title: 'DevOps Excellence',
      description: 'Continuous deployment and infrastructure automation',
      icon: '⚙️'
    }
  ];

  return (
    <div className='home-page'>
      <SEO
        title='Transform Your Business with Technology'
        description='Expert IT consulting, cloud solutions, and digital transformation services for enterprises worldwide. Cloud, AI & analytics, security, and DevOps excellence.'
        path='/home'
      />
      {/* Hero Section */}
      <section className='hero-section'>
        <div className='hero-content'>
          <h1 className='hero-title'>
            Transform Your <span className='gradient-text'>Business</span> with Technology
          </h1>
          <p className='hero-subtitle'>
            Expert IT consulting, cloud solutions, and digital transformation services for enterprises worldwide
          </p>
          <div className='hero-actions'>
            <Button buttonStyle='btn--primary' buttonSize='btn--large'>
              Get Started
            </Button>
            <Button buttonStyle='btn--outline' buttonSize='btn--large'>
              Learn More
            </Button>
          </div>
        </div>
        <div className='hero-graphic'>
          <div className='floating-card card-1'></div>
          <div className='floating-card card-2'></div>
          <div className='floating-card card-3'></div>
        </div>
      </section>

      {/* Features Section */}
      <section className='features-section'>
        <div className='section-header'>
          <h2>Why Choose IURIX?</h2>
          <p>Industry-leading expertise across all technology domains</p>
        </div>
        <div className='features-grid'>
          {features.map(feature => (
            <div key={feature.id} className='feature-card glass-dark'>
              <div className='feature-icon'>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className='stats-section'>
        <div className='stats-grid'>
          <div className='stat-item'>
            <div className='stat-number'>500+</div>
            <div className='stat-label'>Clients Worldwide</div>
          </div>
          <div className='stat-item'>
            <div className='stat-number'>99.9%</div>
            <div className='stat-label'>Uptime SLA</div>
          </div>
          <div className='stat-item'>
            <div className='stat-number'>15+</div>
            <div className='stat-label'>Years Experience</div>
          </div>
          <div className='stat-item'>
            <div className='stat-number'>24/7</div>
            <div className='stat-label'>Support Available</div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='cta-section'>
        <h2>Ready to Transform Your Business?</h2>
        <p>Let our expert team guide you through your digital journey</p>
        <Button buttonStyle='btn--primary' buttonSize='btn--large'>
          Schedule a Consultation
        </Button>
      </section>
    </div>
  );
}
